import { useState } from "react";
import { Button } from "@heroui/react";
import { Trophy, Zap } from "lucide-react";
import { Leaderboard } from "@/components/Leaderboard";
import { SocialFeed } from "@/components/SocialFeed";

export function HomePage() {
  const [selectedTab, setSelectedTab] = useState<"leaderboard" | "feed">(
    "leaderboard"
  );

  return (
    <div className="space-y-6">
      {/* Hero Section */}
      <div className="text-center py-8">
        <h1 className="text-4xl font-bold mb-4">Social Trading Intelligence</h1>
        <p className="text-lg text-default-500 max-w-2xl mx-auto">
          Track the best performing crypto Twitter analysts. See who's making
          accurate calls and follow their alpha in real-time.
        </p>
      </div>

      {/* Tab Buttons */}
      <div className="flex justify-center gap-2">
        <Button
          color={selectedTab === "leaderboard" ? "primary" : "default"}
          variant={selectedTab === "leaderboard" ? "solid" : "bordered"}
          startContent={<Trophy className="w-4 h-4" />}
          onPress={() => setSelectedTab("leaderboard")}
        >
          Leaderboard
        </Button>
        <Button
          color={selectedTab === "feed" ? "primary" : "default"}
          variant={selectedTab === "feed" ? "solid" : "bordered"}
          startContent={<Zap className="w-4 h-4" />}
          onPress={() => setSelectedTab("feed")}
        >
          Alpha Feed
        </Button>
      </div>

      {/* Content */}
      <div className="mt-6">
        {selectedTab === "leaderboard" && <Leaderboard />}
        {selectedTab === "feed" && <SocialFeed />}
      </div>
    </div>
  );
}
